import { doLogout } from './authAction'
import { BASE_URL } from './constant';

export const TOP_CONSIGNEE_LOADING = 'TOP_CONSIGNEE_LOADING';
export const TOP_CONSIGNEE_SUCCESS = 'TOP_CONSIGNEE_SUCCESS';
export const TOP_CONSIGNEE_ERROR = 'TOP_CONSIGNEE_ERROR';

const topConsigneeLoading = bool => {
    return {
        type: TOP_CONSIGNEE_LOADING,
        loading: bool
    }
}

const topConsigneeSuccess = (bool, data) => {
    return {
        type: TOP_CONSIGNEE_SUCCESS,
        success: bool,
        data
    }
}

const topConsigneeError = bool => {
    return {
        type: TOP_CONSIGNEE_ERROR,
        error: bool
    }
}

export const topConsignee = params => {
    return dispatch => {
        dispatch(topConsigneeLoading(true));
        dispatch(topConsigneeSuccess(false, []));
        dispatch(topConsigneeError(false));

        let token = localStorage.getItem('tolaut@token') || null;

        let config = {};

        if (token) {
            config = {
                method: 'POST',
                body: JSON.stringify(params),
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        } else {
            throw Error("Authentication error")
        }

        fetch(BASE_URL + 'topconsignee', config)
            .then(response => {
                if (response.status === 401) {
                    dispatch(doLogout())
                }
                if (!response.ok) {
                    throw Error(response.statusText)
                }

                dispatch(topConsigneeLoading(false));
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                dispatch(topConsigneeSuccess(true, data))
            })
            .catch((err) => {
                dispatch(topConsigneeError(true))
            })
    }
}